export enum ActiveSearchHelpStatus {
  ALL = 'ALL',
  PENDENT = 'PENDENT',
  IN_PROGRESS = 'IN_PROGRESS',
  RESOLVED = 'RESOLVED'
}

export enum ActiveSearchHelpStatusLocated {
  ALL = 'Total',
  PENDENT = 'À resolver',
  IN_PROGRESS = 'Em andamento',
  RESOLVED = 'Resolvida'
}

export enum ActiveSearchHelpStatusTranslated {
  ALL = 'Total - Precisa de ajuda',
  PENDENT = 'À resolver - Precisa de ajuda',
  IN_PROGRESS = 'Em andamento - Precisa de ajuda',
  RESOLVED = 'Resolvidas - Precisa de ajuda'
}
